import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UIService } from '../shared/ui.service';

@Injectable({
  providedIn: 'root'
})
export class AncSettingsService {

  constructor(private http: HttpClient, private uis: UIService) { }
  getAncClinentSettings(): Observable<any>{
    return this.http.get("/api/Client/AncClientsSettings");
  }

  updateAncClientSettings(clSetting: UpdateAncClientSettingsFron) {
    if (!clSetting.isJobInProgress) {
      let dtoObj: UpdateAncClientSettingsDTO = {
        outputType: clSetting.outputType,
        Verbose: clSetting.mode,
        GooglePublishAsEnabled: clSetting.GooglePublishAsEnabled
      }
      return this.http.put("/api/Client/ClientSettings/" + clSetting.clientID, dtoObj).toPromise();
    } else {
      this.uis.showSnackbar(clSetting.name+" Client is Already In Progress", null, 3000, false);
    }

  }
}

export interface AncClientSettings {
  clientID: number;
  name: string;
  originalClientCode: string;
  outputType: string;
  mode: boolean;
  googlePublishAsEnabled: string | boolean;
  oldPublishEnabled: string | boolean;
  isJobInProgress: boolean;
  oldOptype?: string;
  oldmode?: boolean;
  IsSelected?: boolean;
}
export interface UpdateAncClientSettingsFron {
  clientID: number;
  name: string;
  outputType: string;
  mode: boolean;
  isJobInProgress: boolean;
  GooglePublishAsEnabled: boolean;
}
export interface UpdateAncClientSettingsDTO {
  outputType: string;
  Verbose: boolean;
  GooglePublishAsEnabled: boolean;
}
